import React, { useRef, useState } from 'react';
import { MapStepBarDataTypesButtonStyle as S } from './MapStepBarDataTypesButton.style';
import { useClickOutside } from 'hooks/useClickOutside';
import { MapStepDataTypeData } from '../../../MapStepDataTypeData/MapStepDataTypeData';
import { Icon } from 'components/Icon/Icon';

export const MapStepBarDataTypesButton: React.FC = () => {
  const containerRef = useRef(null);
  const [open, setOpen] = useState(false);
  useClickOutside(containerRef, () => setOpen(false));

  return (
    <S.Container ref={containerRef}>
      <S.Button onClick={() => setOpen(!open)} open={open}>
        <Icon icon="helpCircleLine" size={16} color="slate400" />
        <S.ButtonTex>What are data types?</S.ButtonTex>
      </S.Button>
      {open && (
        <S.Box>
          <MapStepDataTypeData />
        </S.Box>
      )}
    </S.Container>
  );
};
